export const SET_PROGRESSBAR = 'SET_PROGRESSBAR';
export const ADD_PROGRESSBAR = 'ADD_PROGRESSBAR';
export const REMOVE_PROGRESSBAR = 'REMOVE_PROGRESSBAR';
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';
export const SET_SNACKBAR = 'SET_SNACKBAR';

export const SET_DIALOG = 'SET_DIALOG';

export const SET_MENU_TYPE = 'SET_MENU_TYPE';
export const ERROR_POPUP = 'ERROR_POPUP';

/**
 * 공통코드 관련 타입
 */
export const GET_CODE = 'GET_CODE';
export const INIT_CODE = 'INIT_CODE';

/**
 * 공통
 */
export const INIT_CHECK_ELEMENT = 'INIT_CHECK_ELEMENT';

/**
 * 인보이스 관련 타입
 */

export const INIT_INVOICE = 'INIT_INVOICE'; // INVOICE 초기화
export const SET_ISSUE_INFO = 'SET_ISSUE_INFO'; // INVOICE ISSUE 초기 정보

export const GET_INVOICE = 'GET_INVOICE'; // 공통 Invoice 상세조회
export const GET_INVOICE_LIST = 'GET_INVOICE_LIST'; // 공통 Invoice List 조회

export const GET_INVOICE_TEMP = 'GET_INVOICE_TEMP';
export const GET_INVOICE_TEMP_LIST = 'GET_INVOICE_TEMP_LIST';

export const SET_INVOICE_LIST = 'SET_INVOICE_LIST'; // SET
export const SET_INVOICE_LIST_TOTAL_AMOUNT = 'SET_INVOICE_LIST_TOTAL_AMOUNT'; // SET

export const IS_INVOICE_SEARCH_VIEW = 'IS_INVOICE_SEARCH_VIEW'; // 검색 후 VIEW FLAG
export const IS_INVOICE_DETAIL_POPUP = 'IS_INVOICE_DETAIL_POPUP'; // 상세보기 FLAG

export const GET_INVOICE_ISSUANCE_LIST = 'GET_INVOICE_ISSUANCE_LIST'; // INQUIRY_0
export const GET_INVOICE_INQUIRY_BY_CASE = 'GET_INVOICE_INQUIRY_BY_CASE'; // INQUIRY_1
export const GET_COPY_ISSUE_INVOICE_LIST = 'GET_COPY_ISSUE_INVOICE_LIST'; // INQUIRY_2
export const GET_INVOICE_CORRECT_LIST = 'GET_INVOICE_CORRECT_LIST'; // INQUIRY_3
export const GET_INVOICE_CORRECT_DETAIL = 'GET_INVOICE_CORRECT_DETAIL';
export const INIT_INVOICE_CORRECT_DETAIL = 'INIT_INVOICE_CORRECT_DETAIL';
export const GET_INVOICE_EMAIL_HISTORY = 'GET_INVOICE_EMAIL_HISTORY'; // INQUIRY_6
export const GET_INVOICE_DETAIL = 'GET_INVOICE_DETAIL'; // 팝업 상세조회
export const GET_COPY_CORRECTION_INVOICE_DETAIL =
  'GET_COPY_CORRECTION_INVOICE_DETAIL';

export const SET_ISSUANCE_INVOICE_LIST = 'SET_ISSUANCE_INVOICE_LIST'; // 확인필요
export const SET_INVOICE_ISUUE = 'SET_INVOICE_ISUUE'; // 확인필요
export const SET_PREVIEW_INVOICE_ISUUE = 'SET_PREVIEW_INVOICE_ISUUE';
export const SET_INVOICE_SAVE = 'SET_INVOICE_SAVE';
export const DELETE_INVOICE_TEMP_LIST = 'DELETE_INVOICE_TEMP_LIST';

export const GET_INVOICE_POS_ISSUANCE_LIST = 'GET_INVOICE_POS_ISSUANCE_LIST'; // POSCRM_0
export const GET_INVOICE_POS_INQUIRY_BY_CASE =
  'GET_INVOICE_POS_INQUIRY_BY_CASE'; // POSCRM_1

export const GET_ISSUE_INVOICE_DETAIL = 'GET_ISSUE_INVOICE_DETAIL'; // 발행 시 Invoice 상세 조회

export const INVOICE_ISSUE_INFO = 'INVOICE_ISSUE_INFO';
export const INIT_INVOICE_ISSUE_INFO = 'INIT_INVOICE_ISSUE_INFO';
export const INVOICE_CHECK_ISSUE_POPUP = 'INVOICE_CHECK_ISSUE_POPUP';
export const INVOICE_PREVIEW_POPUP = 'INVOICE_PREVIEW_POPUP';
export const INVOICE_SAVE_POPUP = 'INVOICE_SAVE_POPUP';
export const INOVICE_SAVE_COMPLETE_POPUP = 'INOVICE_SAVE_COMPLETE_POPUP';
export const INOVICE_ISSUE_COMPLETE_POPUP = 'INOVICE_ISSUE_COMPLETE_POPUP';
export const IS_INVOICE_INIT = 'IS_INVOICE_INIT';

export const GET_MASSIVE_ISSUANCE_VERIFICATION_RESULT =
  'GET_MASSIVE_ISSUANCE_VERIFICATION_RESULT';
export const UPDATE_MASSIVE_ISSUANCE = 'UPDATE_MASSIVE_ISSUANCE';

export const SET_MASSIVE_INVOICE_TEMP_LIST = 'SET_MASSIVE_INVOICE_TEMP_LIST';

export const POST_INVOICE_EMAIL_RESEND = 'POST_INVOICE_EMAIL_RESEND';

/**
 * 통계 관련 타입
 */
export const INIT_STATISTICS = 'INIT_STATISTICS'; // INVOICE 초기화
export const GET_STATISTICS_SUM = 'GET_STATISTICS_SUM';
export const GET_STATISTICS_SUM_DETAIL = 'GET_STATISTICS_SUM_DETAIL';
export const GET_STATISTICS_SUM_POPUP = 'GET_STATISTICS_SUM_POPUP';
export const GET_STATISTICS_PERIOD = 'GET_STATISTICS_PERIOD';
export const GET_STATISTICS_PERIOD_DETAIL = 'GET_STATISTICS_PERIOD_DETAIL';
export const GET_STATISTICS_PERIOD_POPUP = 'GET_STATISTICS_PERIOD_POPUP';
export const GET_STATISTICS_TYPE = 'GET_STATISTICS_TYPE';
export const IS_STATISTICS_SUM_POPUP = 'IS_STATISTICS_SUM_POPUP';
export const IS_STATISTICS_PERIOD_POPUP = 'IS_STATISTICS_PERIOD_POPUP';

export const INIT_STATISTICS_POSCRM = 'INIT_STATISTICS_POSCRM'; // INVOICE 초기화
export const GET_STATISTICS_POSCRM_SUM = 'GET_STATISTICS_POSCRM_SUM';
export const GET_STATISTICS_POSCRM_SUM_DETAIL =
  'GET_STATISTICS_POSCRM_SUM_DETAIL';
export const GET_STATISTICS_POSCRM_SUM_POPUP =
  'GET_STATISTICS_POSCRM_SUM_POPUP';
export const GET_STATISTICS_POSCRM_PERIOD = 'GET_STATISTICS_POSCRM_PERIOD';
export const GET_STATISTICS_POSCRM_PERIOD_DETAIL =
  'GET_STATISTICS_POSCRM_PERIOD_DETAIL';
export const GET_STATISTICS_POSCRM_PERIOD_POPUP =
  'GET_STATISTICS_POSCRM_PERIOD_POPUP';
export const GET_STATISTICS_POSCRM_TYPE = 'GET_STATISTICS_POSCRM_TYPE';
export const IS_STATISTICS_POSCRM_SUM_POPUP = 'IS_STATISTICS_POSCRM_SUM_POPUP';
export const IS_STATISTICS_POSCRM_PERIOD_POPUP =
  'IS_STATISTICS_POSCRM_PERIOD_POPUP';

/**
 * 클라이언트 관련 타입
 */
export const GET_CLIENT_LIST = 'GET_CLIENT_LIST';
export const SET_CLIENT_LIST = 'SET_CLIENT_LIST';
export const INSERT_CLIENT_LIST = 'INSERT_CLIENT_LIST';
export const DELETE_CLIENT_LIST = 'DELETE_CLIENT_LIST';
export const UPDATE_CLIENT = 'UPDATE_CLIENT';
export const SET_UPLOAD_CLIENT_LIST = 'SET_UPLOAD_CLIENT_LIST';
export const IS_CLIENT_DETAIL_POPUP = 'IS_CLIENT_DETAIL_POPUP';
export const INSERT_UPLOAD_CLIENT_LIST = 'INSERT_UPLOAD_CLIENT_LIST';
export const INIT_CLIENT_LIST = 'INIT_CLIENT_LIST';
export const TRADE_REGISTEREDAME_CHECK = 'TRADE_REGISTEREDAME_CHECK';
export const IS_TRADE_REGISTERED_NAME_CHECK = 'IS_TRADE_REGISTERED_NAME_CHECK';
export const TRADE_TIN_CHECK = 'TRADE_TIN_CHECK';
export const IS_TRADE_TIN_CHECK = 'IS_TRADE_TIN_CHECK';
export const GET_CLIENT_STATUS = 'GET_CLIENT_STATUS';
export const IS_TRADE_TIN = 'IS_TRADE_TIN';

/**
 * 아이템 관련 타입
 */
export const GET_ITEM_LIST = 'GET_ITEM_LIST';
export const SET_ITEM_LIST = 'SET_ITEM_LIST';
export const INSERT_ITEM_LIST = 'INSERT_ITEM_LIST';
export const DELETE_ITEM_LIST = 'DELETE_ITEM_LIST';
export const UPDATE_ITEM = 'UPDATE_ITEM';
export const SET_UPLOAD_ITEM_LIST = 'SET_UPLOAD_ITEM_LIST';
export const IS_ITEM_DETAIL_POPUP = 'IS_ITEM_DETAIL_POPUP';
export const INSERT_UPLOAD_ITEM_LIST = 'INSERT_UPLOAD_ITEM_LIST';
export const INIT_ITEM_LIST = 'INIT_ITEM_LIST';
export const ITEM_NAME_CHECK = 'ITEM_NAME_CHECK';
export const IS_ITEM_NAME_CHECK = 'IS_ITEM_NAME_CHECK';

/**
 * 노티스 관련 타입
 */
export const GET_ADVISORY_LIST = 'GET_ADVISORY_LIST';
export const GET_ADVISORY_DETAIL = 'GET_ADVISORY_DETAIL';
export const INSERT_ADVISORY_LIST = 'INSERT_ADVISORY_LIST';
export const INIT_ADVISORY_LIST = 'INIT_ADVISORY_LIST';
export const INIT_ADVISORY_DETAIL = 'INIT_ADVISORY_DETAIL';
export const SET_ADVISORY_PAGE = 'SET_ADVISORY_PAGE';
export const GET_MAIN_ADVISORY_LIST = 'GET_MAIN_ADVISORY_LIST';

/**
 * BOARD 관련 타입
 */
export const GET_BOARD_LIST = 'GET_BOARD_LIST';
export const GET_BOARD_DETAIL = 'GET_BOARD_DETAIL';
export const INIT_BOARD_LIST = 'INIT_BOARD_LIST';
export const INIT_BOARD_DETAIL = 'INIT_BOARD_DETAIL';
export const INSERT_BOARD_POST_LIST = 'INSERT_BOARD_POST_LIST';
export const SET_FAQ_PAGE = 'SET_FAQ_PAGE';

/**
 * ObjectStorage 관련 타입
 */
export const OBJECTSTORAGE_UPLOAD = 'OBJECTSTORAGE_UPLOAD';
export const OBJECTSTORAGE_DOWNLOAD = 'OBJECTSTORAGE_DOWNLOAD';
export const OBJECTSTORAGE_DELETE = 'OBJECTSTORAGE_DELETE';
export const OBJECTSTORAGE_ALWAYSDOWNLOAD_URL =
  'OBJECTSTORAGE_ALWAYSDOWNLOAD_URL';
export const TEMPLATE_DOWNLOAD = 'TEMPLATE_DOWNLOAD';

/**
 * 계정 관련 타입
 */
export const GET_PW_ENCRYPT_KEY = 'GET_PW_ENCRYPT_KEY';
export const INSERT_USER = 'INSERT_USER';
export const IS_TIN = 'IS_TIN';
export const IS_TIN_BRANCHCODE_CHANGE = 'IS_TIN_BRANCHCODE_CHANGE';
export const EXIST_ID = 'EXIST_ID';
export const DESTROY_SIGNUP_ELEMENT = 'DESTROY_SIGNUP_ELEMENT';

export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const GET_USER_FROM_SESSION = 'GET_USER_FROM_SESSION';

export const SEARCH_ID = 'SEARCH_ID';
export const SEND_MAIL_SEARCH_ID = 'SEND_MAIL_SEARCH_ID';
export const SEARCH_PW = 'SEARCH_PW';
export const SEND_MAIL_SEARCH_PW = 'SEND_MAIL_SEARCH_PW';

export const CHANGE_PASSWORD = 'CHANGE_PASSOWRD';
export const CHANGE_PASSWORD_BY_DIALOG = 'CHANGE_PASSWORD_BY_DIALOG';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const INIT_USER = 'INIT_USER';

export const GET_USER = 'GET_USER';
export const UPDATE_USER = 'UPDATE_USER';

export const SEARCH_USER_LIST = 'SEARCH_USER_LIST';
export const CHANGE_USER_STATUS = 'CHANGE_USER_STATUS';
export const FIND_BY_AUTHORIZATION = 'FIND_BY_AUTHOIRZATION';

export const INIT_MAIL = 'INIT_MAIL';

/**
 * 회사 관련 타입
 */
export const GET_COMPANY = 'GET_COMPANY';
export const GET_COMPNAY_BY_TIN_AND_BRANCHCODE =
  'GET_COMPNAY_BY_TIN_AND_BRANCHCODE';
export const INIT_COMPANY = 'INIT_COMPANY';
export const UPDATE_COMPANY = 'UPDATE_COMPANY';
export const UPDATE_INVOICE_SETTING = 'UPDATE_INVOICE_SETTING';
export const DELETE_EMPLOYEE = 'DELETE_EMPLOYEE';
export const INVITE_EMPLOYEE = 'INVITE_EMPLOYEE';

export const INIT_TAXPAYER_DETAIL = 'INIT_TAXPAYER_DETAIL';
export const GET_TAXPAYER_DETAIL = 'GET_TAXPAYER_DETAIL';

/**
 * 내부(internal) 관련 타입
 */
export const INIT_VAT_MONTHLY_LIST = 'INIT_VAT_MONTHLY_LIST';
export const INIT_VAY_MONTHLY_DETAIL = 'INIT_VAY_MONTHLY_DETAIL';
export const INIT_VAT_QUARTERLY_LIST = 'INIT_VAT_QUARTERLY_LIST';
export const INIT_VAT_QUARTERLY_DETAIL = 'INIT_VAY_QUARTERLY_DETAIL';
export const GET_VAT_MONTHLY_LIST = 'GET_VAT_MONTHLY_LIST';
export const GET_VAY_MONTHLY_DETAIL = 'GET_VAY_MONTHLY_DETAIL';
export const GET_VAT_QUARTERLY_LIST = 'GET_VAT_QUARTERLY_LIST';
export const GET_VAT_QUARTERLY_DETAIL = 'GET_VAT_QUARTERLY_DETAIL';

/**
 * JWS 관련 타입
 */
export const INIT_JWS = 'INIT_JWS'; // INVOICE 초기화
export const GET_JWS = 'GET_JWS';
